// src/store/networkErrorSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PermissionErrorStare {
  permission: boolean
  permissionErrorMessage: string | null
}

const initialState: PermissionErrorStare = {
  permission: false,
  permissionErrorMessage: null,
}

const permissionErrorSlice = createSlice({
  name: 'permissionError',
  initialState,
  reducers: {
    setPermission(
      state,
      action: PayloadAction<{ denied: boolean; message?: string }>
    ) {
      state.permission = action.payload.denied
      state.permissionErrorMessage = action.payload.message || null
    },
  },
})

export const { setPermission } = permissionErrorSlice.actions
export default permissionErrorSlice.reducer
